const MobileWarning = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-4 text-center">
            <div className="bg-white rounded-2xl shadow-lg p-6 min-h-[600px] flex flex-col w-full max-w-sm justify-between">

                <div>
                    <h1 className="text-5xl">
                        Engage is currently desktop-only
                    </h1>
                    <p className="mt-4 text-left">
                        Visit on a larger screen in your desktop browser for the full experience.
                    </p>
                </div>

                <div className="flex justify-center items-end space-x-4 flex-1 my-20">
                    <div className="w-24 h-40 bg-black rounded-lg flex items-center justify-center">
                        <span className="text-white text-3xl font-bold">✖</span>
                    </div>
                    <div className="w-28 h-48 bg-blue-500 rounded-lg flex items-center justify-center shadow-lg">
                        <span className="text-white text-3xl font-bold">✖</span>
                    </div>
                    <div className="w-26 h-44 bg-red-300 rounded-lg flex items-center justify-center">
                        <span className="text-white text-3xl font-bold opacity-50">✖</span>
                    </div>
                </div>

                <button className="mt-auto bg-blue-500 text-white p-3 w-full rounded cursor-pointer hover:bg-blue-600 transition">
                    Copy Link
                </button>
            </div>
        </div>
    );
};

export default MobileWarning;
